import { useFrame } from "@react-three/fiber";

import { Mesh } from "three";

import { useTheme } from "@mui/material";
import { OrbitControls } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import { useRef } from "react";
import { GridShaderMaterial } from "./GridShaderMaterial";

export const Globe = () => {
  return (
    <Canvas
      style={{ height: "100%", width: "100%" }}
      camera={{ position: [0, 2, 8], fov: 25, far: 1000, near: 0.01 }}
      gl={{
        antialias: true,
        alpha: true,
        powerPreference: "high-performance",
      }}
    >
      <GlobeScene />
      <OrbitControls
        enableZoom={false}
        enablePan={false}
        enableRotate={false}
      />
    </Canvas>
  );
};

const GlobeScene = () => {
  const meshRef = useRef<Mesh>(null);
  const theme = useTheme();

  useFrame((_state, delta) => {
    if (meshRef.current) {
      meshRef.current.rotation.x += delta * 0.02;
      meshRef.current.rotation.y -= delta * 0.04;
      meshRef.current.rotation.z -= delta * 0.03;
    }
  });

  return (
    <>
      <ambientLight intensity={1} color={theme.palette.yellow.main} />
      <directionalLight
        position={[0, 0, -4]}
        intensity={0.5}
        color={theme.palette.yellow.main}
      />
      <mesh
        ref={meshRef}
        position={[0, -7, 0]}
        onPointerDown={(e: any) => {
          e.stopPropagation();
          if (e.target && "setPointerCapture" in e.target) {
            e.target.setPointerCapture(e.pointerId);

            document.body.style.cursor = "grab";
          }
        }}
        onPointerUp={(e: any) => {
          e.stopPropagation();
          if (e.target && "releasePointerCapture" in e.target) {
            e.target.releasePointerCapture(e.pointerId);
          }
          document.body.style.cursor = "pointer";
        }}
        onPointerMove={(e) => {
          if (meshRef.current && e.buttons === 1) {
            meshRef.current.rotation.y += e.movementX * 0.0015;
            meshRef.current.rotation.x += e.movementY * 0.0005;
          }
        }}
        onPointerOver={(e) => {
          if (document.body.style.cursor === "default") {
            document.body.style.cursor = "pointer";
          }
        }}
        onPointerOut={(e) => {
          document.body.style.cursor = "default";
        }}
      >
        <sphereGeometry args={[8.75, 210, 210]} />
        <GridShaderMaterial
          baseWidth={0.025}
          maxWidth={0.045}
          opacity={0.35}
          gridSize={30}
          grid={0.725}
        />
      </mesh>
    </>
  );
};
